import { render, staticRenderFns } from "./EditWishContent.vue?vue&type=template&id=f396d602&scoped=true&"
import script from "./EditWishContent.vue?vue&type=script&lang=js&"
export * from "./EditWishContent.vue?vue&type=script&lang=js&"
import style0 from "./EditWishContent.vue?vue&type=style&index=0&id=f396d602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f396d602",
  null
  
)

export default component.exports